module.exports = __webpack_public_path__ + "img/5.342de525.png";